<template>
  <main>
    <h1 class="name">{{ info.author }}</h1>
    <h3 class="aka">Aka: {{ getAka }}</h3>

    <p class="intro">{{ info.intro }}</p>
    <p class="dreams" v-for="(dream, index) in info.dreams" :key="index">
      {{ dream }}
    </p>
    <div class="btnSocial">
      <Button
        v-for="(buttons, index) in info.socialButtons"
        :key="index"
        :title="buttons.title"
        :link="buttons.link"
        target="_blank"
        style="margin-left: 15px"
      />
    </div>
    <div class="booksRead">
      <h4>Books Read</h4>
      <div
        class="booksReadList"
        v-for="(book, index) in info.booksRead"
        :key="index"
      >
        {{ book }}
      </div>
    </div>
    <div class="booksRead">
      <h4>Favourite Qoutes</h4>
      <div
        class="qouteLiked"
        v-for="(qoute, index) in info.qoutes"
        :key="index"
      >
        <span style="font-weight: bold">{{ qoute.author }}:</span>
        {{ qoute.qoute }}
      </div>
    </div>
  </main>
</template>

<script>
import Button from "./Button.vue";
import mainData from "../models/mainData.json";
export default {
  components: {
    Button,
  },
  data() {
    return {
      info: mainData,
    };
  },
  computed: {
    getAka: function () {
      return this.info.aka.join(" / ");
    },
  },
};
</script>

<style>
main {
  width: 590px;
  margin: 0 auto;
}
h1 {
  font-size: 4.242rem;
  line-height: 4.5rem;
  margin-top: 2rem;
}
h4 {
  margin-block-end: 5px;
}
p {
  margin-bottom: 0;
  margin-top: 1.5rem;
  line-height: 1.5rem;
}
.intro {
  font-size: 1.6rem;
  line-height: 1.3;
  margin-top: 0;
}
.name {
  margin-bottom: 0;
}
.aka {
  margin-top: 5px;
  margin-bottom: 40px;
  font-size: 13px;
}
.btnSocial {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.qouteLiked {
  font-size: 15px;
  line-height: 2;
}
.booksReadList {
  display: contents;
  line-height: 1.5;
  font-size: 15px;
}
.booksRead div:not(:first-child):not(:last-child):after {
  content: ", ";
}

@media only screen and (max-width: 812px) {
  body {
    margin: 16px;
  }

  main {
    width: 100%;
  }
}
</style>